export const uk = {
    'validation-empty-name': 'Не указано название видео',
    'validation-empty-text': 'Значение не может быть пустым'
};
